<template>
  <CRow>
    <CCol col="12" md="12" lg="12">
      <b-card header-tag="header" header-bg-variant="dark" fluid>
        <template #header>
          <p class="mb-0" style="">
            <strong>Data Posisi</strong>
          </p>
        </template>

        <CRow>
          <CCol cols="12" md="12" lg="12">
            <b-tabs v-model="activeTab" content-class="mt-3" align="center">
              <b-tab :title="$store.state.tab.divisi" active>
                <Divisi :activeTab="activeTab" />
              </b-tab>
              <b-tab :title="$store.state.tab.posisi">
                <Posisi :activeTab="activeTab" />
              </b-tab>
              <b-tab :title="$store.state.tab.hirarki">
                <Hirarki :activeTab="activeTab" />
              </b-tab>
            </b-tabs>
          </CCol>
        </CRow>
      </b-card>
    </CCol>
  </CRow>
</template>

<script>
import Divisi from "./divisi/divisi";
import Posisi from "./posisi/posisi";
import Hirarki from "./hirarki/hirarki.vue";
export default {
  components: {
    Divisi,
    Posisi,
    Hirarki,
  },
  name: "divisi",
  data() {
    return {
      activeTab: 0,
    };
  },
};
</script>
